import { BaseService } from "services/_baseService";

class TourPackageCategoryAdminService extends BaseService<any> {
  constructor() {
    super(`tour-package-categories`);
  }
}

export default new TourPackageCategoryAdminService();
